import { default as startCCPADelete } from "./start-ccpa-delete.json";
import { default as userDevice } from "./user-device.json";
import { default as userDevices } from "./user-devices.json";
import { default as userPoints } from "./user-points.json";
import { default as verifyOTPProfile } from "./verify-otp-profile.json";

const data: { [key: string]: object } = {
  "start-ccpa-delete": startCCPADelete,
  "user-device": userDevice,
  "user-devices": userDevices,
  "user-points": userPoints,
  "verify-otp-profile": verifyOTPProfile,
};

const user = {
  getStartCCPADelete: () => data["start-ccpa-delete"],
  getUserDevice: () => data["user-device"],
  getUserDevices: () => data["user-devices"],
  getUserPoints: () => data["user-points"],
  getVerifiedProfile: () => data["verify-otp-profile"],
};

export default user;
